import { createSelector } from 'reselect';

import { getFilterPosibilities } from './';

export default filterOn =>
  createSelector([getFilterPosibilities(filterOn)], shopAttributes =>
    shopAttributes.map(attribute => ({ label: attribute, value: attribute }))
  );
